import React from "react";
import ButtonSelect from "./ButtonSelect.js";

interface ButtonPlayerViewProps {
  selectedView?: string;
  onChange?: func;
  displayPricing?: Boolean;
  displayOwner?: Boolean;
  displayTraits?: Boolean;
}

const ButtonPlayerView: React.FC<ButtonPlayerViewProps> = ({
  selectedView,
  onChange,
  displayPricing,
  displayOwner,
  displayTraits,
}) => {
  const buttons = { profile: "Profile", stats: "Attr.", ovr: "OVRs" };
  if (displayTraits) buttons.traits = "Traits";
  if (displayPricing) buttons.pricing = "Pricing";
  if (displayOwner) buttons.owner = "Owner";
  return (
    <ButtonSelect
      buttons={buttons}
      selected={selectedView || "profile"}
      onChange={onChange}
      selectedClassName="btn-info text-white"
    />
  );
};

export default ButtonPlayerView;
